import { createContext, useContext, type ReactNode } from "react";

// DEMO MODE: authentication disabled. A fake user is provided so existing
// screens that rely on `useAuth()` keep working without any login flow.
const DEMO_USER = {
  id: "00000000-0000-0000-0000-000000000001",
  email: "demo@jaingauravyatra.app",
  user_metadata: { full_name: "Demo Devotee" },
  app_metadata: {},
  aud: "authenticated",
  created_at: new Date().toISOString(),
} as any;

const DEMO_SESSION = { user: DEMO_USER, access_token: "demo", refresh_token: "demo", token_type: "bearer", expires_in: 3600 } as any;

interface AuthCtx {
  user: any;
  session: any;
  loading: boolean;
  isAdmin: boolean;
  signOut: () => Promise<void>;
}

const Ctx = createContext<AuthCtx>({
  user: DEMO_USER,
  session: DEMO_SESSION,
  loading: false,
  isAdmin: true,
  signOut: async () => {},
});

export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <Ctx.Provider value={{ user: DEMO_USER, session: DEMO_SESSION, loading: false, isAdmin: true, signOut: async () => {} }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
